var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6347 6.50199L13.6347 2.52074C13.6346 2.26657 13.5742 2.01605 13.4584 1.78981C13.3425 1.56358 13.1746 1.36811 12.9684 1.21951C12.7622 1.07091 12.5236 0.973432 12.2724 0.935113C12.0211 0.896793 11.7643 0.918728 11.5232 0.999108L8.51003 2.00349C8.40147 2.03979 8.283 2.03209 8.18005 1.98205L5.86769 0.857628C5.75655 0.803568 5.63349 0.778645 5.51008 0.7852C5.38666 0.791756 5.26693 0.829575 5.16214 0.895105C5.05735 0.960634 4.97094 1.05172 4.91102 1.15982C4.8511 1.26791 4.81963 1.38946 4.81959 1.51306L4.81959 4.07373L1.15718 4.07414L0.719957 4.51137L1.15718 4.94859L4.82 4.94859L4.81959 7.50968C4.81953 7.63336 4.85094 7.75502 4.91085 7.86323C4.97076 7.97143 5.05722 8.06261 5.16208 8.1282C5.26694 8.19379 5.38676 8.23163 5.51027 8.23816C5.63378 8.24468 5.75692 8.21969 5.86811 8.16552L8.18046 7.0411C8.28324 6.99103 8.40154 6.98318 8.51003 7.01924L11.5232 8.02363C11.7643 8.10401 12.0211 8.12594 12.2724 8.08762C12.5236 8.0493 12.7622 7.95183 12.9684 7.80323C13.1746 7.65463 13.3425 7.45915 13.4584 7.23292C13.5742 7.00668 13.6346 6.75616 13.6347 6.50199Z",
    fill: "url(#paint0_linear_7670_66128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7670_66128",
    x1: 16.7824,
    y1: -3.7663,
    x2: 0.227095,
    y2: -4.75202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.6c08b9e899410862e745f959932f9794.svg";
export { ForwardRef as ReactComponent };